const links = {
	CV: "https://drive.google.com/file/d/18PhAWUxTI2kfHP9aFV69JTyK_Q2I-qHw/view?usp=drive_link",
	MemoriaTFG:
		"https://drive.google.com/file/d/18ZwlWohkn2NMDO4Al5yO1SmDl7r19ZaD/view?usp=sharing",
	Axioma: "https://www.edicionesenhuida.es/producto/axioma/",
	GitHub: "https://github.com/Gonza116",
	LinkedIn: "https://linkedin.com/in/gonzalogarciagranes",
	Mail: "mailto:gonzalogranes@gmail.com",
};

export default links;
